import { ApiError } from '../../lib/apiClient';
import { getErrorMessage } from '../../lib/errors';
import { planLimitMessage, type PlanLimitMessageOptions } from './planLabels';

/**
 * The message for a failed write: the plan sentence when a cap refused it
 * (402 `PLAN_LIMIT_REACHED`), the usual message otherwise.
 */
export function planErrorMessage(
  caught: unknown,
  fallback: string,
  options: PlanLimitMessageOptions = {},
): string {
  if (caught instanceof ApiError && caught.isPlanLimitReached) {
    return planLimitMessage(caught.plan, options);
  }
  return getErrorMessage(caught, fallback);
}

/**
 * True for a 402 the Upsell can draw: `PLAN_REQUIRED` or `PLAN_LIMIT_REACHED`
 * with its body fields parsed. Catch sites keep such an error as it came and
 * hand it to `UpsellFromError` instead of flattening it into a message.
 */
export function isPlanError(caught: unknown): caught is ApiError {
  return (
    caught instanceof ApiError &&
    caught.plan !== null &&
    (caught.isPlanRequired || caught.isPlanLimitReached)
  );
}
